const results = [
  {
    text: "Represented a national sports federation in a high-value contract dispute. Matter resolved in client's favour.",
    area: "Sports Law",
  },
  {
    text: "Advised a listed company on a complex tax litigation matter before the Income Tax Appellate Tribunal.",
    area: "Taxation",
  },
  {
    text: "Successfully defended an individual in a high-profile criminal matter at the Delhi High Court.",
    area: "Litigation",
  },
];

export default function CaseResults() {
  return (
    <section data-testid="case-results-section" className="py-24 md:py-32 bg-navy-base">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            Track Record
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white">
            Outcomes that speak.
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {results.map((result, i) => (
            <div
              key={result.area}
              data-testid={`case-result-${i}`}
              className="animate-on-scroll border border-gold/10 bg-navy-dark p-8 relative"
            >
              <span className="absolute top-6 right-6 text-xs tracking-widest uppercase text-gold/40 font-body">
                {result.area}
              </span>
              <div className="text-gold text-5xl font-heading leading-none mb-6">"</div>
              <p className="text-sm md:text-base text-gray-300 font-body leading-relaxed italic">
                {result.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
